import * as api from 'src/api/chat-product/chat-prodcut';
import { updateLiveProductTypeAndSpecialSaleAll } from 'src/api/product';
import type { AxiosResponse } from 'axios';
import { initialState } from './state';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ProductResponse } from 'src/admin-entity/interface/chat-product/chat-product.interface';

export const fetchProducts = createAsyncThunk<ProductResponse[], number>(
    'adminProduct/fetchProducts',
    async lsBroadcastId => {
        const response: AxiosResponse<ProductResponse[]> = await api.fetchProducts(lsBroadcastId);
        return response.data;
    },
);

export const addProduct = createAsyncThunk<ProductResponse[], { lsBroadcastId: number; productIds: number[] }>(
    'adminProduct/addProduct',
    async ({ lsBroadcastId, productIds }) => {
        const response: AxiosResponse<ProductResponse[]> = await api.addProduct(lsBroadcastId, productIds);
        return response.data;
    },
);

export const deleteProduct = createAsyncThunk<ProductResponse[], { lsBroadcastId: number; productId: number }>(
    'adminProduct/deleteProduct',
    async ({ lsBroadcastId, productId }) => {
        const response: AxiosResponse<ProductResponse[]> = await api.deleteProduct(lsBroadcastId, productId);
        return response.data;
    },
);

export const setProductSortOrder = createAsyncThunk<ProductResponse[], { lsBroadcastId: number; order: number[] }>(
    'adminProduct/setSortOrder',
    async ({ lsBroadcastId, order }) => {
        const response: AxiosResponse<ProductResponse[]> = await api.setProductSortOrder(lsBroadcastId, order);
        return response.data;
    },
);

export const updateProductVisibility = createAsyncThunk<
    ProductResponse[],
    { lsBroadcastId: number; productId: number; productActive: boolean }
>('adminProduct/updateVisibility', async ({ lsBroadcastId, productId, productActive }) => {
    const response: AxiosResponse<ProductResponse[]> = await api.updateProductVisibility(
        lsBroadcastId,
        productId,
        productActive,
    );
    return response.data;
});

export const updateProductNowStatus = createAsyncThunk<
    ProductResponse[],
    { lsBroadcastId: number; productId: number; productNow: boolean }
>('adminProduct/updateNowStatus', async ({ lsBroadcastId, productId, productNow }) => {
    const response: AxiosResponse<ProductResponse[]> = await api.updateProductNowStatus(
        lsBroadcastId,
        productId,
        productNow,
    );
    return response.data;
});

export const updateProductTypeAndSpecialSaleAll = createAsyncThunk<
    ProductResponse[],
    { lsBroadcastId: number; productIds: number[]; productType?: number; isSpecialSale?: boolean }
>(
    'adminProduct/updateProductTypeAndSpecialSaleAll',
    async ({ lsBroadcastId, productIds, productType, isSpecialSale }, { rejectWithValue }) => {
        try {
            const response: AxiosResponse<ProductResponse[]> = await updateLiveProductTypeAndSpecialSaleAll(
                lsBroadcastId,
                {
                    productIds,
                    productType,
                    isSpecialSale,
                },
            );
            return response.data;
        } catch (err: any) {
            return rejectWithValue(err?.response?.data);
        }
    },
);

const adminProductSlice = createSlice({
    name: 'adminProduct',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchProducts.fulfilled, (state, { payload }) => {
                state.items = payload;
            })
            .addCase(addProduct.fulfilled, (state, { payload }) => {
                state.items = payload;
            })
            .addCase(deleteProduct.fulfilled, (state, { payload }) => {
                state.items = payload;
            })
            .addCase(setProductSortOrder.fulfilled, (state, { payload }) => {
                state.items = payload;
            })
            .addCase(updateProductVisibility.fulfilled, (state, { payload }) => {
                state.items = payload;
            })
            .addCase(updateProductNowStatus.fulfilled, (state, { payload }) => {
                state.items = payload;
            })
            .addCase(updateProductTypeAndSpecialSaleAll.fulfilled, (state, { payload }) => {
                state.items = payload;
            });
    },
});

export default adminProductSlice.reducer;
